import JobAction from './JobAction.vue'

export default JobAction
